
export const withComputeError = {
  methods: {
    computeErrors () {
      Object.keys(this.$refs).forEach((key) => {
        if (key.indexOf('input') !== 0) return;
        const el = this.$refs[key];
        if (typeof el._computeErrors !== 'function') return;
        el._computeErrors();
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixins/input-wrapper.mixin.js